// extracted by mini-css-extract-plugin
export default {"Mention":"MentionElement_Mention__qq9QJ","MentionSelected":"MentionElement_MentionSelected__47t9M"};